import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['club', 'team', 'players'];

  connect() {
    this.filterTeams();
  }

  filterTeams() {
    if (!this.hasClubTarget || !this.hasTeamTarget) return;

    const clubId = this.clubTarget.value;
    const selectedOption = this.teamTarget.selectedOptions[0];
    const selectedIsVisible = selectedOption && this.optionMatchesClub(selectedOption, clubId);
    let firstVisibleValue = '';

    Array.from(this.teamTarget.options).forEach((option) => {
      const visible = this.optionMatchesClub(option, clubId);
      option.hidden = !visible;
      option.disabled = !visible;
      if (visible && option.value && firstVisibleValue === '') firstVisibleValue = option.value;
    });

    if (!selectedIsVisible) this.teamTarget.value = firstVisibleValue;
    this.filterPlayers();
  }

  filterPlayers() {
    if (!this.hasPlayersTarget) return;

    const clubId = this.hasClubTarget ? this.clubTarget.value : '';
    const teamId = this.hasTeamTarget ? this.teamTarget.value : '';

    Array.from(this.playersTarget.options).forEach((option) => {
      const matchesClub = !clubId || option.dataset.clubId === clubId;
      const matchesTeam = !teamId || option.dataset.teamId === teamId;
      const visible = !option.value || (matchesClub && matchesTeam);
      option.hidden = !visible;
      option.disabled = !visible;
      if (!visible) option.selected = false;
    });
  }

  optionMatchesClub(option, clubId) {
    return !option.value || !clubId || option.dataset.clubId === clubId;
  }
}
